import { EmploymentStatusEnum, IncomeIntervalEnum } from './generated/graphql';

import { Option } from '../components/shared/types';
import { capitalizeFirstLetter } from '../utils/text';

const EmploymentStatusLabelMap = {
  [EmploymentStatusEnum.Employed]: 'Employed',
  [EmploymentStatusEnum.NotEmployed]: 'Not Employed',
  [EmploymentStatusEnum.Retired]: 'Retired',
} as const;
export const employmentStatusOptions: Option[] = Object.values(EmploymentStatusEnum).map(
  (value) => ({
    label: EmploymentStatusLabelMap[value],
    value,
  }),
);

// `Weekly` and `BiWeekly` are deprecated but keeping them for backwards compatibility.
export const getPayFrequencyOptions = (isUneditable: boolean) =>
  Object.values(IncomeIntervalEnum)
    .filter(
      (frequency) =>
        isUneditable ||
        (frequency !== IncomeIntervalEnum.Weekly && frequency !== IncomeIntervalEnum.Biweekly),
    )
    .map((frequency: IncomeIntervalEnum) => ({
      label: capitalizeFirstLetter(frequency),
      value: frequency,
    }));

export class Employment {
  id?: number;
  status: EmploymentStatusEnum;
  name?: string;
  job_title?: string;
  phone_number?: string;
  years_at_job?: number;
  months_at_job?: number;
  gross_income?: number;
  pay_frequency?: IncomeIntervalEnum;

  constructor() {
    this.status = EmploymentStatusEnum.Employed;
    this.name = '';
    this.job_title = '';
    this.phone_number = '';
    this.pay_frequency = IncomeIntervalEnum.Annually;
  }
}
